module.exports = __webpack_public_path__ + "img/platinum-logo-2.e703c774.png";